// import React, { useState, useEffect, useRef } from "react";
// import "../Frontend/UserProfile/UserProfile.css";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../../services/api";
// import APP_CONFIG from "../../config/appConfig";
// import useAuth from "../../hooks/useAuth";
// import { Form, Button } from "react-bootstrap";
// import { useUser } from "../../context/UserContext";
// import ScreenLoader from "../HtmlElements/ScreenLoader";
// import Alert from "../HtmlElements/Alert";
// import { useConfig } from "../../context/AppConfigContext";
// import UserPreferenceSidebar from "./UserPreferenceSidebar";
// import { updatePersonalProfile } from "../../services/userService";
// import * as FeatherIcon from "react-feather";
// import IOSSpinner from "../HtmlElements/IOSSpinner";
// import { routeBasedOnSubscription } from "../../services/commonService";

// export default function UserProfile() {
//   useAuth();
//   const { user, handleLogout } = useUser();

//   const [loader, setLoader] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [apiError, setApiError] = useState("");
//   // const [image, setImage] = useState('');
//   const [isEmailEditable, setIsEmailEditable] = useState(false);
//   const [isPasswordEditable, setIsPasswordEditable] = useState(false);

//   // --- Section toggle (System Settings shows first) ---
//   const [activeSection, setActiveSection] = useState("personal");

//   // --- Feedback Overlay State ---
//   const [showStatusOverlay, setShowStatusOverlay] = useState(false);
//   const [statusStage, setStatusStage] = useState("loading"); // 'loading', 'success', 'error'
//   const [statusMessage, setStatusMessage] = useState("");

//   // --- Personal form state (editable) ---
//   const [personalFormData, setPersonalFormData] = useState({
//     name: "",
//     designation: "",
//     company: "",
//     business_unit: "",
//     linkedin_url: "",
//     country: "",
//   });

//   // const [formData, setFormData] = useState({
//   //   firstname: user?.firstname || '',
//   //   lastname: user?.lastname || '',
//   //   title: user?.title || '',
//   //   designation: user?.designation || '',
//   //   email: user?.email || '',
//   //   // password: user?.password || '',
//   //   company_name: user?.company_name || '',
//   //   phone: user?.phone || '',
//   //   country: user?.country || ''
//   // });

//   const [formData, setFormData] = useState({
//     firstname: user?.firstname || "",
//     lastname: user?.lastname || "",
//     title: APP_CONFIG?.growth_iq_user_roles?.user?.growth_iq_role_name || "",
//     designation: user?.industry || "",
//     email: user?.email || "",
//     company_name: user?.company_name_for_growth_iq || "",
//     phone: user?.phone || "",
//     country: user?.country || "",

//     email: user?.email || "",
//     credits: user?.credits ?? 0,
//     allowed_subscription_quota: user?.allowed_subscription_quota ?? 0,
//     demo: user?.demo,
//     growth_iq: user?.growth_iq,
//     has_ask_growth_access: user?.has_ask_growth_access,
//     has_comp_iq_access: user?.has_comp_iq_access,
//     has_deep_research_access: user?.has_deep_research_access,
//     is_freemium_company: user?.is_freemium_company,
//     no_of_ask_growth_limit: user?.no_of_ask_growth_limit,
//     no_of_comp_iq_access_limit: user?.no_of_comp_iq_access_limit,
//     no_of_deep_research_limit: user?.no_of_deep_research_limit,
//   });

//   const navigate = useNavigate();
//   const { userId } = useParams();
//   const { appConfig } = useConfig();

//   // useEffect(() => {
//   //   setLoader(true);

//   //   setFormData({
//   //     firstname: user?.firstname || "",
//   //     lastname: user?.lastname || "",
//   //     title: user?.title || "",
//   //     email: user?.email || "",
//   //     // password: user?.password || '',
//   //     designation: user?.designation || "",
//   //     company_name: user?.company_name || "",
//   //     phone: user?.phone || "",
//   //     country: user?.country || "",
//   //   });

//   //   setLoader(false);
//   // }, [user]);

//   useEffect(() => {
//     setLoader(true);

//     setFormData({
//       // firstname: user?.firstname || "",
//       // lastname: user?.lastname || "",
//       name: user?.firstname + " " + user?.lastname,
//       title: APP_CONFIG?.growth_iq_user_roles[user?.growth_iq_role_name] || "",
//       designation: user?.industry || "",
//       email: user?.email || "",
//       company_name: user?.company_name_for_growth_iq || "",
//       phone: user?.phone || "",
//       country: user?.country || "",

//       email: user?.email || "",
//       credits: user?.credits ?? 0,
//       allowed_subscription_quota: user?.allowed_subscription_quota ?? 0,
//       demo: user?.demo,
//       growth_iq: user?.growth_iq,
//       has_ask_growth_access: user?.has_ask_growth_access,
//       has_comp_iq_access: user?.has_comp_iq_access,
//       has_deep_research_access: user?.has_deep_research_access,
//       is_freemium_company: user?.is_freemium_company,
//       no_of_ask_growth_limit: user?.no_of_ask_growth_limit,
//       no_of_comp_iq_access_limit: user?.no_of_comp_iq_access_limit,
//       no_of_deep_research_limit: user?.no_of_deep_research_limit,
//     });

//     // Pre-populate personal form from user context
//     setPersonalFormData({
//       name: ((user?.firstname || "") + " " + (user?.lastname || "")).trim(),
//       designation: user?.designation || "",
//       company: user?.company_name_for_growth_iq_demo || "",
//       business_unit: user?.business_unit || "",
//       linkedin_url: user?.linkedin_url || "",
//       country: user?.user_country || "",
//     });

//     setLoader(false);
//   }, [user]);

//   const handlePersonalChange = (e) => {
//     const { name, value } = e.target;
//     setPersonalFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePersonalSave = async (e) => {
//     e.preventDefault();
//     setApiError("");

//     try {
//       setStatusStage("loading");
//       setShowStatusOverlay(true);

//       // Split name into first and last name
//       const nameParts = personalFormData.name.trim().split(" ");
//       const firstName = nameParts[0] || "";
//       const lastName = nameParts.slice(1).join(" ") || "";

//       const payload = {
//         api_token: user?.api_token || "",
//         deviceid: "default-device",
//         first_name: firstName,
//         last_name: lastName,
//         designation: personalFormData.designation,
//         business_unit: personalFormData.business_unit,
//         linkedin_url: personalFormData.linkedin_url,
//         user_country: personalFormData.country,
//         company_name_for_growth_iq: user?.company_name_for_growth_iq || "",
//         company_name_for_growth_iq_demo: personalFormData.company,
//       };

//       const response = await updatePersonalProfile(payload);
//       if (response.status === 200 || response.status === "success") {
//         setStatusStage("success");
//         setStatusMessage("Details Updated");
//       } else {
//         setStatusStage("error");
//         setStatusMessage(
//           response.message ||
//             "There was an issue in Updating your Details please try again"
//         );
//       }
//     } catch (error) {
//       console.error("Save Personal Info Error:", error);
//       setStatusStage("error");
//       setStatusMessage(
//         "There was an issue in Updating your Details please try again"
//       );
//     } finally {
//       // Done
//     }
//   };

//   const handleSectionClick = (section) => {
//     setActiveSection(section);
//   };

//   // if (!appConfig) {
//   //   return <div> </div>;
//   // }
//   // const countryOptions = appConfig.country_options;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));

//     // Clear the error for the current field
//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: "",
//     }));
//     // console.log(formData);
//   };

//   // const onImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     setImage(URL.createObjectURL(file));
//   //   }
//   // }

//   const validateForm = () => {
//     let newErrors = {};

//     if (!formData.firstname) {
//       newErrors.firstname = "First Name is required";
//     } else if (
//       /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstname)
//     ) {
//       newErrors.firstname = "Special characters are not allowed in First Name";
//     }

//     if (!formData.lastname) {
//       newErrors.lastname = "Last Name is required";
//     } else if (
//       /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastname)
//     ) {
//       newErrors.lastname = "Special characters are not allowed in Last Name";
//     }

//     if (
//       formData.designation &&
//       /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)
//     ) {
//       newErrors.designation =
//         "Special characters are not allowed in Designation";
//     }

//     if (isEmailEditable && formData.email) {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       if (!emailRegex.test(formData.email)) {
//         newErrors.email = "Please enter a valid email address";
//       }
//     }

//     if (isPasswordEditable && formData.password) {
//       if (formData.password.length < 8) {
//         newErrors.password = "Password must be at least 8 characters";
//       } else if (!/[A-Z]/.test(formData.password)) {
//         newErrors.password =
//           "Password must contain at least one uppercase letter";
//       } else if (!/[0-9]/.test(formData.password)) {
//         newErrors.password = "Password must contain at least one number";
//       } else if (!/[!@#$%^&*]/.test(formData.password)) {
//         newErrors.password =
//           "Password must contain at least one special character (!@#$%^&*)";
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!validateForm()) {
//       return;
//     }

//     const formattedData = {
//       // id: userId,
//       // profileImage: image,
//       name: formData.name,
//       // lastname: formData.lastname,
//       title: formData.title,
//       designation: formData.designation,
//       email: formData.email,
//       password: formData.password,
//       company_name: formData.company_name,
//       phone: formData.phone,
//       country: formData.country,
//     };

//     setLoader(true);

//     try {
//       // if(userId){
//       //   formattedData.id = userId;
//       //   delete(formattedData.password)
//       // }

//       if (formattedData.password) {
//         delete formattedData.password;
//       }

//       const response = await api.post("/users/update_user_info", formattedData);
//       if (response.data.status === 201 || response.data.status === 200) {
//         sessionStorage.setItem("successMessage", response.data.result.message);
//         // navigate('/users/change_password');
//         navigate("/users/personalisation");
//       } else {
//         setApiError(
//           response.data.result.message ||
//             "An error occurred while saving the user."
//         );
//       }
//     } catch (error) {
//       const errorMsg =
//         error.response?.data?.message ||
//         "An error occurred while saving the user.";
//       setApiError(errorMsg);
//       console.error("Error saving user:", error);
//     }
//     setLoader(false);
//   };

//   const handleCancel = () => {
//     const routePath = routeBasedOnSubscription(user, handleLogout);
//     if (routePath) {
//       navigate(routePath, { replace: true });
//     }
//   };

//   return (
//     <div className="user_profile_wrapper">
//       {loader === true && <ScreenLoader />}
//       <div className="container-fluid">
//         <div className="user_profile_subblock">
//           {apiError && <Alert type="danger" message={apiError} />}
//           <div className="row">
//             {/* <div className='client_head_left'>
//               <h5 className="client_head">Client admin login</h5>
//             </div> */}

//             <div
//               className="col-md-2"
//               style={{ borderRight: "solid 0.1rem #98A4AA33" }}
//             >
//               <div className="sidebar_profile">
//                 <UserPreferenceSidebar
//                   activeSection={activeSection}
//                   onSectionClick={handleSectionClick}
//                 />
//               </div>
//             </div>

//             <div className="col-md-10">
//               {/* ── Personal Form (shown when Personal is active) ── */}
//               {activeSection === "personal" && (
//                 <div
//                   className="userprofile_right"
//                   style={{ border: "none", position: "relative" }}
//                 >
//                   <div className="row">
//                     <div className="col-md-12">
//                       <Form
//                         onSubmit={handlePersonalSave}
//                         className="user_form_info"
//                         autoComplete="off"
//                       >
//                         <div className="row">
//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="name"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.name}
//                                 onChange={handlePersonalChange}
//                               />
//                               <Form.Label className="form-label">
//                                 Name
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="designation"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.designation}
//                                 onChange={handlePersonalChange}
//                               />
//                               <Form.Label className="form-label">
//                                 Designation
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="company"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.company}
//                                 onChange={handlePersonalChange}
//                               />
//                               <Form.Label className="form-label">
//                                 Company
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="business_unit"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.business_unit}
//                                 onChange={handlePersonalChange}
//                               />
//                               <Form.Label className="form-label">
//                                 Business Unit
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="url"
//                                 name="linkedin_url"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.linkedin_url}
//                                 onChange={handlePersonalChange}
//                                 placeholder="https://linkedin.com/in/..."
//                               />
//                               <Form.Label className="form-label">
//                                 LinkedIn URL
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="country"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={personalFormData.country}
//                                 onChange={handlePersonalChange}
//                               />
//                               <Form.Label className="form-label">
//                                 Country
//                               </Form.Label>
//                             </div>
//                           </div>
//                         </div>

//                         <div className="col-md-12 pt-2">
//                           <div className="prev_next_block float-end">
//                             <Button
//                               type="submit"
//                               className="add_account_companies"
//                               style={{
//                                 padding: "5px 10px",
//                                 backgroundColor: "rgb(35, 36, 40)",
//                                 fontSize: "13px",
//                                 fontWeight: "600",
//                                 color: "rgb(255, 255, 255)",
//                                 border: "none",
//                                 borderRadius: "6px",
//                               }}
//                             >
//                               Save
//                             </Button>
//                           </div>
//                         </div>
//                       </Form>

//                       {/* --- Status Overlay Card --- */}
//                       {showStatusOverlay && (
//                         <div className="personal-status-overlay">
//                           <div className="status-card">
//                             {statusStage === "loading" && (
//                               <div className="status-content">
//                                 <IOSSpinner />
//                                 <p className="mt-3">Updating Details...</p>
//                               </div>
//                             )}

//                             {statusStage === "success" && (
//                               <div className="status-content">
//                                 <FeatherIcon.CheckCircle
//                                   size={48}
//                                   color="#28a745"
//                                 />
//                                 <h5 className="mt-3">{statusMessage}</h5>
//                                 <Button
//                                   className="mt-3 close-status-btn"
//                                   onClick={() => setShowStatusOverlay(false)}
//                                 >
//                                   Close
//                                 </Button>
//                               </div>
//                             )}

//                             {statusStage === "error" && (
//                               <div className="status-content">
//                                 <FeatherIcon.AlertCircle
//                                   size={48}
//                                   color="#dc3545"
//                                 />
//                                 <p className="mt-3 status-error-text">
//                                   {statusMessage}
//                                 </p>
//                                 <Button
//                                   className="mt-3 close-status-btn"
//                                   onClick={() => setShowStatusOverlay(false)}
//                                 >
//                                   Try Again
//                                 </Button>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ── System Settings Form (shown by default) ── */}
//               {activeSection === "system-settings" && (
//                 <div
//                   className="userprofile_right"
//                   style={{ border: "none", position: "relative" }}
//                 >
//                   <div className="row">
//                     <div className="col-md-12">
//                       <Form
//                         onSubmit={handleSubmit}
//                         className="user_form_info"
//                         autoComplete="off"
//                       >
//                         <div className="row">
//                           {/* <div className='col-md-12'>
//                             <div className='user_profile_change mb-3'>
//                                 <div className='img_profile_block'>
//                                   <img
//                                     className="profile_picture"
//                                     src={APP_CONFIG.AVATAR_URL + "background=0D8ABC&color=fff&name=" + user?.firstname + " " + user?.lastname + '&rounded=true&bold=true&font-size=0.50'}
//                                     alt="icon"
//                                   />
//                                 </div>
//                             </div>
//                           </div> */}

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="firstname"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.name}
//                                 onChange={handleChange}
//                                 disabled="disabled"
//                               ></Form.Control>
//                               <Form.Label className="form-label">
//                                 User name
//                               </Form.Label>
//                             </div>
//                             {errors.name && (
//                               <div className="text-danger custom_error_msg pt-2 px-2">
//                                 {errors.name}
//                               </div>
//                             )}
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.email}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Email
//                               </Form.Label>
//                             </div>
//                           </div>

//                           {/* <div className='col-md-6'></div> */}

//                           {/* <div className="col-md-6">
//                           <div className="form-control-info">
//                             <Form.Control
//                               type="text"
//                               name="lastname"
//                               className="form-input"
//                               style={{ marginLeft: "5px" }}
//                               value={formData.lastname}
//                               onChange={handleChange}
//                             ></Form.Control>
//                             <Form.Label className="form-label">
//                               Last name
//                             </Form.Label>
//                           </div>
//                           {errors.lastname && (
//                             <div className="text-danger custom_error_msg pt-2 px-2">
//                               {errors.lastname}
//                             </div>
//                           )}
//                         </div> */}

//                           {/* <div className="col-md-6"></div>
//                         <div className="col-md-6"></div> */}

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="title"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.title}
//                                 onChange={handleChange}
//                                 disabled="disabled"
//                               ></Form.Control>
//                               <Form.Label className="form-label">
//                                 Role
//                               </Form.Label>
//                             </div>
//                           </div>

//                           {/* <div className='col-md-12'>
//                             <div className="form-control-info  d-inline-block" style={{width: "95%"}}>
//                               <Form.Control
//                                 type="text"
//                                 name="email"
//                                 className="form-input me-2"
//                                 style={{ marginLeft: '5px' }}
//                                 value={formData.email}
//                                 onChange={handleChange}
//                                 disabled={!isEmailEditable}
//                               />
//                               <label htmlFor="text" className="form-label">Email </label>
//                             </div>
//                             <div className='d-inline-block pl-4' style={{width: "5%", textAlign: "center"}}>
//                               <FeatherIcon.Edit style={{pointerEvents: 'all'}} onClick={() => setIsEmailEditable(!isEmailEditable)} className='' /> {' '}
//                             </div>
//                             {errors.email && <div className="text-danger custom_error_msg pt-2 px-2">{errors.email}</div>}
//                           </div> */}

//                           {/* <div className="col-md-12">
//                             <div className="form-control-info position-relative d-inline-block" style={{width: "95%"}}>
//                               <div className="d-flex align-items-center">
//                                 <Form.Control
//                                   type="password"
//                                   name="password"
//                                   className="form-input me-2"
//                                   style={{ marginLeft: '5px', flex: 1 }}
//                                   value={formData.password}
//                                   onChange={handleChange}
//                                   disabled={!isPasswordEditable}
//                                 />
//                               </div>
//                               <label htmlFor="text" className="form-label">Password</label>
//                             </div>
//                             <div className='d-inline-block pl-4' style={{width: "5%", textAlign: "center"}}>
//                               <FeatherIcon.Edit style={{pointerEvents: 'all'}} onClick={() => setIsPasswordEditable(!isPasswordEditable)} className='icons_table ' /> {' '}
//                             </div>

//                             {errors.password && (
//                               <div className="text-danger custom_error_msg pt-2 px-2">
//                                 {errors.password}
//                               </div>
//                             )}
//                           </div> */}

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="company_name"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.company_name}
//                                 disabled="disabled"
//                               ></Form.Control>
//                               <Form.Label className="form-label">
//                                 Company name
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="designation"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.designation}
//                                 onChange={handleChange}
//                                 disabled="disabled"
//                               ></Form.Control>
//                               <label htmlFor="text" className="form-label">
//                                 Department{" "}
//                               </label>
//                             </div>
//                             {errors.designation && (
//                               <div className="text-danger custom_error_msg pt-2 px-2">
//                                 {errors.designation}
//                               </div>
//                             )}
//                           </div>

//                           {/* <div className="col-md-6"></div>
//                           <div className='col-md-6'></div> */}

//                           {/* <div className='col-md-6'>
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 name="phone"
//                                 className="form-input"
//                                 style={{marginLeft : '5px'}}
//                                 value={formData.phone}
//                                 onChange={handleChange}
//                               ></Form.Control>
//                               <label htmlFor="text" className="form-label">Your contact </label>
//                             </div>
//                             {errors.phone && <div className="text-danger custom_error_msg pt-2 px-2">{errors.phone}</div>}
//                           </div> */}
//                           {/* <div className='col-md-6'></div> */}

//                           {/* <div className="col-md-6">
//                           <div className="form-control-info">
//                             <Form.Control
//                               className="form-input"
//                               as="select"
//                               name="country"
//                               style={{ paddingLeft: "15px" }}
//                               value={formData.country}
//                               onChange={handleChange}
//                             >
//                               <option key="" value="">
//                                 Select Country
//                               </option>
//                               {Object.keys(countryOptions).map((key) => (
//                                 <option key={`country-${key}`} value={key}>
//                                   {countryOptions[key]}
//                                 </option>
//                               ))}
//                             </Form.Control>
//                             <label htmlFor="text" className="form-label">
//                               Country{" "}
//                             </label>
//                           </div>
//                           {errors.country && (
//                             <div className="text-danger custom_error_msg pt-2 px-2">
//                               {errors.country}
//                             </div>
//                           )}
//                         </div> */}

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.credits}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Credits
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.allowed_subscription_quota}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Subscription Quota
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.growth_iq ? "Yes" : "No"}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Growth IQ Access
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={
//                                   formData.has_comp_iq_access ? "Yes" : "No"
//                                 }
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Competitor IQ Access
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.no_of_comp_iq_access_limit}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Competitor IQ Limit
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={
//                                   formData.has_ask_growth_access ? "Yes" : "No"
//                                 }
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Ask Growth IQ Access
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.no_of_ask_growth_limit}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Ask Growth IQ Limit
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6">
//                             <div className="form-control-info">
//                               <Form.Control
//                                 type="text"
//                                 className="form-input"
//                                 style={{ marginLeft: "5px" }}
//                                 value={formData.no_of_deep_research_limit}
//                                 disabled="disabled"
//                               />
//                               <Form.Label className="form-label">
//                                 Deep Research Limit
//                               </Form.Label>
//                             </div>
//                           </div>

//                           <div className="col-md-6"></div>

//                           <div className="col-md-6"></div>
//                         </div>

//                         <div className="col-md-12  pt-2">
//                           <div className="prev_next_block float-end">
//                             <Button
//                               type="button"
//                               onClick={handleCancel}
//                               className="previous_btn mr-2"
//                             >
//                               Cancel
//                             </Button>
//                             {/* <Button
//                             type="submit"
//                             className="personalisation_button"
//                           >
//                             Next
//                           </Button> */}

//                             <Button
//                               type="submit"
//                               // className="personalisation_button"
//                               className="add_account_companies"
//                               style={{
//                                 padding: "5px 10px",
//                                 backgroundColor: "rgb(35, 36, 40)",
//                                 fontSize: "13px",
//                                 fontWeight: "600",
//                                 color: "rgb(255, 255, 255)",
//                                 border: "none",
//                                 borderRadius: "6px",
//                               }}
//                               onClick={handleLogout}
//                             >
//                               Sign out
//                             </Button>
//                           </div>
//                         </div>

//                         <div
//                           className="cancel_cross_btn"
//                           onClick={handleCancel}
//                           title="Cancel"
//                           style={{
//                             position: "absolute",
//                             top: "0px",
//                             right: "0px",
//                             cursor: "pointer",
//                             zIndex: 1,
//                           }}
//                         >
//                           {/* <FeatherIcon.X size={18} /> */}
//                           <span style={{ padding: "5px" }}>x</span>
//                         </div>
//                       </Form>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // import React, { useState,useEffect } from 'react';
// // import useAuth from '../../hooks/useAuth';
// // import APP_CONFIG from '../../config/appConfig';
// // import { useUser } from '../../context/UserContext';

// // export default function ViewProfile(props) {
// //     useAuth(); //User Authentication

// //     const userRoles = APP_CONFIG.user_roles;
// //     const countries = APP_CONFIG.country_options;
// //     const { user } = useUser();

// //     return (
// //         <div className="add_company_wrapper">
// //             <div className="container mt-3 p-4">
// //                 <h4 className="blue add_user_heading">View Profile</h4>
// //                 <div className="row pt-4">
// //                     <div className="col-md-12">
// //                         <div className="mb-3 row">
// //                             <div className="col-md-6 ">
// //                                 <div className="view_profile_block">
// //                                 <div className="row">
// //                                     <div className="col-md-3">
// //                                         <p className="left_label_profile">Name :</p>
// //                                     </div>
// //                                     <div className="col-md-9">
// //                                         <p className="right_label_profile">{user?.firstname} {user?.lastname}</p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6 ">
// //                             <div className="view_profile_block">
// //                                 <div className="row">
// //                                     <div className="col-md-4">
// //                                         <p className="left_label_profile">Email :</p>
// //                                     </div>
// //                                     <div className="col-md-8">
// //                                         <p className="right_label_profile">{user?.email} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-3">
// //                                         <p className="left_label_profile">Contact :</p>
// //                                     </div>
// //                                     <div className="col-md-9">
// //                                         <p className="right_label_profile">{user?.phone} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-4">
// //                                         <p className="left_label_profile">User role :</p>
// //                                     </div>
// //                                     <div className="col-md-8">
// //                                         <p className="right_label_profile">{userRoles[user?.role]} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">
// //                                 <div className="row">
// //                                     <div className="col-md-3">
// //                                         <p className="left_label_profile">Country :</p>
// //                                     </div>
// //                                     <div className="col-md-9">
// //                                         <p className="right_label_profile">{countries[user?.country]} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-4">
// //                                         <p className="left_label_profile">Company name :</p>
// //                                     </div>
// //                                     <div className="col-md-8">
// //                                         <p className="right_label_profile">{user?.company_name} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-3">
// //                                         <p className="left_label_profile">Designation :</p>
// //                                     </div>
// //                                     <div className="col-md-9">
// //                                         <p className="right_label_profile">{user?.designation} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-4">
// //                                         <p className="left_label_profile">Download access :</p>
// //                                     </div>
// //                                     <div className="col-md-8">
// //                                         <p className="right_label_profile">{(user?.download_access === 0) ? "No" : "Yes"} </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>

// //                             <div className="col-md-6">
// //                             <div className="view_profile_block">

// //                                 <div className="row">
// //                                     <div className="col-md-3">
// //                                         <p className="left_label_profile">Verified :</p>
// //                                     </div>
// //                                     <div className="col-md-9">
// //                                         <p className="right_label_profile">{(user?.isVerified === 0) ? "No" : "Yes" } </p>
// //                                     </div>
// //                                 </div>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // }

import React, { useState, useEffect, useRef } from "react";
import "../Frontend/UserProfile/UserProfile.css";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import APP_CONFIG from "../../config/appConfig";
import useAuth from "../../hooks/useAuth";
import { Form, Button, ProgressBar } from "react-bootstrap";
import { useUser } from "../../context/UserContext";
import ScreenLoader from "../HtmlElements/ScreenLoader";
import Alert from "../HtmlElements/Alert";
import { useConfig } from "../../context/AppConfigContext";
import UserPreferenceSidebar from "./UserPreferenceSidebar";
import { updatePersonalProfile, generateTwinning } from "../../services/userService";
import * as FeatherIcon from "react-feather";
import IOSSpinner from "../HtmlElements/IOSSpinner";
import { routeBasedOnSubscription } from "../../services/commonService";

export default function UserProfile() {
  useAuth();
  const { user, handleLogout, setUser } = useUser();

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  // const [image, setImage] = useState('');
  const [isEmailEditable, setIsEmailEditable] = useState(false);
  const [isPasswordEditable, setIsPasswordEditable] = useState(false);

  // --- Section toggle (System Settings shows first) ---
  const [activeSection, setActiveSection] = useState("personal");

  // --- Feedback Overlay State ---
  const [showStatusOverlay, setShowStatusOverlay] = useState(false);
  const [statusStage, setStatusStage] = useState("loading"); // 'loading', 'success', 'error'
  const [statusMessage, setStatusMessage] = useState("");
  const [twinningProgress, setTwinningProgress] = useState(0);

  // --- Personal form state (editable) ---
  const [personalFormData, setPersonalFormData] = useState({
    firstname: "",
    lastname: "",
    designation: "",
    company: "",
    business_unit: "",
    linkedin_url: "",
    country: "",
  });

  // const [formData, setFormData] = useState({
  //   firstname: user?.firstname || '',
  //   lastname: user?.lastname || '',
  //   title: user?.title || '',
  //   designation: user?.designation || '',
  //   email: user?.email || '',
  //   // password: user?.password || '',
  //   company_name: user?.company_name || '',
  //   phone: user?.phone || '',
  //   country: user?.country || ''
  // });

  const [formData, setFormData] = useState({
    firstname: user?.firstname || "",
    lastname: user?.lastname || "",
    title: APP_CONFIG?.growth_iq_user_roles?.user?.growth_iq_role_name || "",
    designation: user?.industry || "",
    email: user?.email || "",
    company_name: user?.company_name_for_growth_iq || "",
    phone: user?.phone || "",
    country: user?.country || "",

    email: user?.email || "",
    credits: user?.credits ?? 0,
    allowed_subscription_quota: user?.allowed_subscription_quota ?? 0,
    demo: user?.demo,
    growth_iq: user?.growth_iq,
    has_ask_growth_access: user?.has_ask_growth_access,
    has_comp_iq_access: user?.has_comp_iq_access,
    has_deep_research_access: user?.has_deep_research_access,
    is_freemium_company: user?.is_freemium_company,
    no_of_ask_growth_limit: user?.no_of_ask_growth_limit,
    no_of_comp_iq_access_limit: user?.no_of_comp_iq_access_limit,
    no_of_deep_research_limit: user?.no_of_deep_research_limit,
  });

  const navigate = useNavigate();
  const { userId } = useParams();
  const { appConfig } = useConfig();

  // useEffect(() => {
  //   setLoader(true);

  //   setFormData({
  //     firstname: user?.firstname || "",
  //     lastname: user?.lastname || "",
  //     title: user?.title || "",
  //     email: user?.email || "",
  //     // password: user?.password || '',
  //     designation: user?.designation || "",
  //     company_name: user?.company_name || "",
  //     phone: user?.phone || "",
  //     country: user?.country || "",
  //   });

  //   setLoader(false);
  // }, [user]);

  useEffect(() => {
    setLoader(true);

    setFormData({
      // firstname: user?.firstname || "",
      // lastname: user?.lastname || "",
      name: user?.firstname + " " + user?.lastname,
      title: APP_CONFIG?.growth_iq_user_roles[user?.growth_iq_role_name] || "",
      designation: user?.industry || "",
      email: user?.email || "",
      company_name: user?.company_name_for_growth_iq || "",
      phone: user?.phone || "",
      country: user?.country || "",

      email: user?.email || "",
      credits: user?.credits ?? 0,
      allowed_subscription_quota: user?.allowed_subscription_quota ?? 0,
      demo: user?.demo,
      growth_iq: user?.growth_iq,
      has_ask_growth_access: user?.has_ask_growth_access,
      has_comp_iq_access: user?.has_comp_iq_access,
      has_deep_research_access: user?.has_deep_research_access,
      is_freemium_company: user?.is_freemium_company,
      no_of_ask_growth_limit: user?.no_of_ask_growth_limit,
      no_of_comp_iq_access_limit: user?.no_of_comp_iq_access_limit,
      no_of_deep_research_limit: user?.no_of_deep_research_limit,
    });

    // Pre-populate personal form from user context
    setPersonalFormData({
      firstname: user?.firstname || "",
      lastname: user?.lastname || "",
      designation: user?.designation || "",
      company: user?.company_name_for_growth_iq_demo || "",
      business_unit: user?.business_unit || "",
      linkedin_url: user?.linkedin_url || "",
      country: user?.user_country || "",
    });

    setLoader(false);
  }, [user]);

  useEffect(() => {
    let interval;
    if (statusStage === "twinning") {
      setTwinningProgress(0);
      interval = setInterval(() => {
        setTwinningProgress((prev) => {
          if (prev < 40) return prev + 2;
          if (prev < 70) return prev + 1;
          if (prev < 90) return prev + 0.5;
          if (prev < 98) return prev + 0.1;
          return prev;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [statusStage]);

  const handlePersonalChange = (e) => {
    const { name, value } = e.target;
    setPersonalFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePersonalSave = async (e) => {
    e.preventDefault();
    setApiError("");

    try {
      setStatusStage("loading");
      setShowStatusOverlay(true);
      setTwinningProgress(0);

      // Validation
      if (
        !personalFormData.firstname.trim() ||
        !personalFormData.lastname.trim()
      ) {
        setStatusStage("error");
        setShowStatusOverlay(true);
        setStatusMessage("First Name and Last Name are mandatory.");
        return;
      }

      const payload = {
        api_token: user?.api_token || "",
        deviceid: "default-device",
        first_name: personalFormData.firstname.trim(),
        last_name: personalFormData.lastname.trim(),
        designation: personalFormData.designation,
        business_unit: personalFormData.business_unit,
        linkedin_url: personalFormData.linkedin_url,
        user_country: personalFormData.country,
        company_name_for_growth_iq: user?.company_name_for_growth_iq || "",
        company_name_for_growth_iq_demo: personalFormData.company,
      };

      const response = await updatePersonalProfile(payload);
      if (response.status === 200 || response.status === "success") {
        setStatusStage("twinning");
        setStatusMessage("Analyzing your company and role to deliver precise, tailored insights, opportunities, and decision support.\nThis typically takes 1–2 minutes");

        // Update userContext on the fly
        setUser((prevUser) => ({
          ...prevUser,
          firstname: personalFormData.firstname.trim(),
          lastname: personalFormData.lastname.trim(),
          designation: personalFormData.designation,
          company_name_for_growth_iq_demo: personalFormData.company,
          business_unit: personalFormData.business_unit,
          linkedin_url: personalFormData.linkedin_url,
          user_country: personalFormData.country,
        }));

        const twinningPayload = {
          company_name: personalFormData.company.trim(),
          role: personalFormData.designation.trim(),
          username: `${personalFormData.firstname.trim()} ${personalFormData.lastname.trim()}`,
        };

        try {
          await generateTwinning(twinningPayload);
          setTwinningProgress(100);
          setTimeout(() => {
            setStatusStage("success");
            setStatusMessage("User Personalisation Data Generated.");
          }, 600);
        } catch (err) {
          console.error("Twinning Error:", err);
          setTwinningProgress(100);
          setTimeout(() => {
            setStatusStage("success");
            setStatusMessage("User Personalisation Data Generated.");
          }, 600);
        }
      } else {
        setStatusStage("error");
        setStatusMessage(
          response.message ||
            "There was an issue in Updating your Details please try again"
        );
      }
    } catch (error) {
      console.error("Save Personal Info Error:", error);
      setStatusStage("error");
      setStatusMessage(
        "There was an issue in Updating your Details please try again"
      );
    } finally {
      // Done
    }
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };

  // if (!appConfig) {
  //   return <div> </div>;
  // }
  // const countryOptions = appConfig.country_options;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    // console.log(formData);
  };

  // const onImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(URL.createObjectURL(file));
  //   }
  // }

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstname) {
      newErrors.firstname = "First Name is required";
    } else if (
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstname)
    ) {
      newErrors.firstname = "Special characters are not allowed in First Name";
    }

    if (!formData.lastname) {
      newErrors.lastname = "Last Name is required";
    } else if (
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastname)
    ) {
      newErrors.lastname = "Special characters are not allowed in Last Name";
    }

    if (
      formData.designation &&
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)
    ) {
      newErrors.designation =
        "Special characters are not allowed in Designation";
    }

    if (isEmailEditable && formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    if (isPasswordEditable && formData.password) {
      if (formData.password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      } else if (!/[A-Z]/.test(formData.password)) {
        newErrors.password =
          "Password must contain at least one uppercase letter";
      } else if (!/[0-9]/.test(formData.password)) {
        newErrors.password = "Password must contain at least one number";
      } else if (!/[!@#$%^&*]/.test(formData.password)) {
        newErrors.password =
          "Password must contain at least one special character (!@#$%^&*)";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    const formattedData = {
      // id: userId,
      // profileImage: image,
      name: formData.name,
      // lastname: formData.lastname,
      title: formData.title,
      designation: formData.designation,
      email: formData.email,
      password: formData.password,
      company_name: formData.company_name,
      phone: formData.phone,
      country: formData.country,
    };

    setLoader(true);

    try {
      // if(userId){
      //   formattedData.id = userId;
      //   delete(formattedData.password)
      // }

      if (formattedData.password) {
        delete formattedData.password;
      }

      const response = await api.post("/users/update_user_info", formattedData);
      if (response.data.status === 201 || response.data.status === 200) {
        sessionStorage.setItem("successMessage", response.data.result.message);
        // navigate('/users/change_password');
        navigate("/users/personalisation");
      } else {
        setApiError(
          response.data.result.message ||
            "An error occurred while saving the user."
        );
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "An error occurred while saving the user.";
      setApiError(errorMsg);
      console.error("Error saving user:", error);
    }
    setLoader(false);
  };

  const handleCancel = () => {
    const routePath = routeBasedOnSubscription(user, handleLogout);
    if (routePath) {
      navigate(routePath, { replace: true });
    }
  };

  return (
    <div className="user_profile_wrapper">
      {loader === true && <ScreenLoader />}
      <div className="container-fluid">
        <div className="user_profile_subblock">
          {apiError && <Alert type="danger" message={apiError} />}
          <div className="row">
            {/* <div className='client_head_left'>
              <h5 className="client_head">Client admin login</h5>
            </div> */}

            <div
              className="col-md-2"
              style={{ borderRight: "solid 0.1rem #98A4AA33" }}
            >
              <div className="sidebar_profile">
                <UserPreferenceSidebar
                  activeSection={activeSection}
                  onSectionClick={handleSectionClick}
                />
              </div>
            </div>

            <div className="col-md-10">
              {/* ── Personal Form (shown when Personal is active) ── */}
              {activeSection === "personal" && (
                <div
                  className="userprofile_right"
                  style={{ border: "none", position: "relative" }}
                >
                  <div className="row">
                    <div className="col-md-12">
                      <Form
                        onSubmit={handlePersonalSave}
                        className="user_form_info"
                        autoComplete="off"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="firstname"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.firstname}
                                onChange={handlePersonalChange}
                                required
                              />
                              <Form.Label className="form-label">
                                First Name{" "}
                                <span className="text-danger">*</span>
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="lastname"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.lastname}
                                onChange={handlePersonalChange}
                                required
                              />
                              <Form.Label className="form-label">
                                Last Name <span className="text-danger">*</span>
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="designation"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.designation}
                                onChange={handlePersonalChange}
                              />
                              <Form.Label className="form-label">
                                Designation
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="company"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.company}
                                onChange={handlePersonalChange}
                              />
                              <Form.Label className="form-label">
                                Company
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="business_unit"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.business_unit}
                                onChange={handlePersonalChange}
                              />
                              <Form.Label className="form-label">
                                Business Unit
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="url"
                                name="linkedin_url"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.linkedin_url}
                                onChange={handlePersonalChange}
                                placeholder="https://linkedin.com/in/..."
                              />
                              <Form.Label className="form-label">
                                LinkedIn URL
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="country"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={personalFormData.country}
                                onChange={handlePersonalChange}
                              />
                              <Form.Label className="form-label">
                                Country
                              </Form.Label>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 pt-2">
                          <div className="prev_next_block float-end">
                            <Button
                              type="submit"
                              className="add_account_companies"
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "rgb(35, 36, 40)",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(255, 255, 255)",
                                border: "none",
                                borderRadius: "6px",
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Form>

                      {/* --- Status Overlay Card --- */}
                      {showStatusOverlay && (
                        <div className="personal-status-overlay">
                          <div className="status-card" style={{ maxWidth: statusStage === "twinning" ? "450px" : "350px", borderRadius: "16px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)", border: "1px solid rgba(255,255,255,0.8)", background: "rgba(255, 255, 255, 0.95)" }}>
                            {statusStage === "loading" && (
                              <div className="status-content">
                                <IOSSpinner />
                                <p className="mt-3">Updating Details...</p>
                              </div>
                            )}

                            {statusStage === "twinning" && (
                              <div className="status-content" style={{ padding: "10px 0" }}>
                                <div style={{ 
                                  background: "linear-gradient(135deg, rgba(78, 107, 202, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%)",
                                  padding: "15px",
                                  borderRadius: "50%",
                                  marginBottom: "15px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}>
                                  <FeatherIcon.CheckCircle size={32} color="#4e6bca" />
                                </div>
                                <h5 className="mt-2" style={{ fontFamily: "Outfit, Inter, sans-serif", fontWeight: "700", color: "#1e1c25" }}>Initializing your Personal Intelligence Layer…</h5>
                                <p className="mt-2 text-center" style={{ fontSize: "13px", color: "#6c757d", lineHeight: "1.5", whiteSpace: "pre-line" }}>
                                  {statusMessage}
                                </p>
                                <div style={{ width: "100%", marginTop: "20px" }}>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#4b5563" }}>Data Syncing</span>
                                    <span style={{ fontSize: "15px", fontWeight: "700", color: "#4e6bca" }}>{Math.round(twinningProgress)}%</span>
                                  </div>
                                  <div style={{ width: "100%", height: "8px", backgroundColor: "#edf2f7", borderRadius: "10px", overflow: "hidden", boxShadow: "inset 0 1px 2px rgba(0,0,0,0.1)" }}>
                                    <div style={{ 
                                      width: `${twinningProgress}%`, 
                                      height: "100%", 
                                      background: "linear-gradient(90deg, #4e6bca 0%, #6366f1 100%)", 
                                      borderRadius: "10px", 
                                      transition: "width 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                                      boxShadow: "0 2px 4px rgba(78, 107, 202, 0.2)"
                                    }}></div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {statusStage === "success" && (
                              <div className="status-content" style={{ padding: "10px 0" }}>
                                <div style={{ 
                                  background: "linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(40, 167, 69, 0.2) 100%)",
                                  padding: "20px",
                                  borderRadius: "50%",
                                  marginBottom: "15px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}>
                                  <FeatherIcon.CheckCircle size={40} color="#28a745" />
                                </div>
                                <h5 className="mt-2" style={{ fontFamily: "Outfit, Inter, sans-serif", fontWeight: "700", color: "#1e1c25" }}>Success!</h5>
                                <p className="mt-2 text-center" style={{ fontSize: "14px", color: "#4b5563", lineHeight: "1.5" }}>
                                  {statusMessage}
                                </p>
                                <Button
                                  className="mt-3 close-status-btn"
                                  style={{ 
                                    backgroundColor: "#232428", 
                                    border: "none", 
                                    padding: "8px 25px", 
                                    borderRadius: "8px",
                                    fontWeight: "600",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                                  }}
                                  onClick={() => setShowStatusOverlay(false)}
                                >
                                  OK
                                </Button>
                              </div>
                            )}

                            {statusStage === "error" && (
                              <div className="status-content" style={{ padding: "10px 0" }}>
                                <div style={{ 
                                  background: "linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(220, 53, 69, 0.2) 100%)",
                                  padding: "20px",
                                  borderRadius: "50%",
                                  marginBottom: "15px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}>
                                  <FeatherIcon.AlertCircle size={40} color="#dc3545" />
                                </div>
                                <h5 className="mt-2" style={{ fontFamily: "Outfit, Inter, sans-serif", fontWeight: "700", color: "#1e1c25" }}>Error</h5>
                                <p className="mt-2 text-center status-error-text" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                                  {statusMessage}
                                </p>
                                <Button
                                  className="mt-3 close-status-btn"
                                  style={{ 
                                    backgroundColor: "#232428", 
                                    border: "none", 
                                    padding: "8px 25px", 
                                    borderRadius: "8px",
                                    fontWeight: "600",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                                  }}
                                  onClick={() => setShowStatusOverlay(false)}
                                >
                                  Try Again
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* ── System Settings Form (shown by default) ── */}
              {activeSection === "system-settings" && (
                <div
                  className="userprofile_right"
                  style={{ border: "none", position: "relative" }}
                >
                  <div className="row">
                    <div className="col-md-12">
                      <Form
                        onSubmit={handleSubmit}
                        className="user_form_info"
                        autoComplete="off"
                      >
                        <div className="row">
                          {/* <div className='col-md-12'>
                            <div className='user_profile_change mb-3'>
                                <div className='img_profile_block'>
                                  <img
                                    className="profile_picture"
                                    src={APP_CONFIG.AVATAR_URL + "background=0D8ABC&color=fff&name=" + user?.firstname + " " + user?.lastname + '&rounded=true&bold=true&font-size=0.50'}
                                    alt="icon" 
                                  />
                                </div>
                            </div>
                          </div> */}

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="firstname"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.name}
                                onChange={handleChange}
                                disabled="disabled"
                              ></Form.Control>
                              <Form.Label className="form-label">
                                User name
                              </Form.Label>
                            </div>
                            {errors.name && (
                              <div className="text-danger custom_error_msg pt-2 px-2">
                                {errors.name}
                              </div>
                            )}
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.email}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Email
                              </Form.Label>
                            </div>
                          </div>

                          {/* <div className='col-md-6'></div> */}

                          {/* <div className="col-md-6">
                          <div className="form-control-info">
                            <Form.Control
                              type="text"
                              name="lastname"
                              className="form-input"
                              style={{ marginLeft: "5px" }}
                              value={formData.lastname}
                              onChange={handleChange}
                            ></Form.Control>
                            <Form.Label className="form-label">
                              Last name
                            </Form.Label>
                          </div>
                          {errors.lastname && (
                            <div className="text-danger custom_error_msg pt-2 px-2">
                              {errors.lastname}
                            </div>
                          )}
                        </div> */}

                          {/* <div className="col-md-6"></div>
                        <div className="col-md-6"></div> */}

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="title"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.title}
                                onChange={handleChange}
                                disabled="disabled"
                              ></Form.Control>
                              <Form.Label className="form-label">
                                Role
                              </Form.Label>
                            </div>
                          </div>

                          {/* <div className='col-md-12'>
                            <div className="form-control-info  d-inline-block" style={{width: "95%"}}>
                              <Form.Control
                                type="text"
                                name="email"
                                className="form-input me-2"
                                style={{ marginLeft: '5px' }}
                                value={formData.email}
                                onChange={handleChange}
                                disabled={!isEmailEditable}
                              />
                              <label htmlFor="text" className="form-label">Email </label>
                            </div>
                            <div className='d-inline-block pl-4' style={{width: "5%", textAlign: "center"}}>
                              <FeatherIcon.Edit style={{pointerEvents: 'all'}} onClick={() => setIsEmailEditable(!isEmailEditable)} className='' /> {' '}
                            </div>
                            {errors.email && <div className="text-danger custom_error_msg pt-2 px-2">{errors.email}</div>}
                          </div> */}

                          {/* <div className="col-md-12">
                            <div className="form-control-info position-relative d-inline-block" style={{width: "95%"}}>
                              <div className="d-flex align-items-center">
                                <Form.Control
                                  type="password"
                                  name="password"
                                  className="form-input me-2"
                                  style={{ marginLeft: '5px', flex: 1 }}
                                  value={formData.password}
                                  onChange={handleChange}
                                  disabled={!isPasswordEditable}
                                />
                              </div>
                              <label htmlFor="text" className="form-label">Password</label>
                            </div>
                            <div className='d-inline-block pl-4' style={{width: "5%", textAlign: "center"}}>
                              <FeatherIcon.Edit style={{pointerEvents: 'all'}} onClick={() => setIsPasswordEditable(!isPasswordEditable)} className='icons_table ' /> {' '}
                            </div>

                            {errors.password && (
                              <div className="text-danger custom_error_msg pt-2 px-2">
                                {errors.password}
                              </div>
                            )}
                          </div> */}

                          {/* <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="company_name"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.company_name}
                                disabled="disabled"
                              ></Form.Control>
                              <Form.Label className="form-label">
                                Company name
                              </Form.Label>
                            </div>
                          </div> */}

                          {/* <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="designation"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.designation}
                                onChange={handleChange}
                                disabled="disabled"
                              ></Form.Control>
                              <label htmlFor="text" className="form-label">
                                Department{" "}
                              </label>
                            </div>
                            {errors.designation && (
                              <div className="text-danger custom_error_msg pt-2 px-2">
                                {errors.designation}
                              </div>
                            )}
                          </div> */}

                          {/* <div className="col-md-6"></div>
                          <div className='col-md-6'></div> */}

                          {/* <div className='col-md-6'>
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                name="phone"
                                className="form-input"
                                style={{marginLeft : '5px'}}
                                value={formData.phone}
                                onChange={handleChange}
                              ></Form.Control>
                              <label htmlFor="text" className="form-label">Your contact </label>
                            </div>
                            {errors.phone && <div className="text-danger custom_error_msg pt-2 px-2">{errors.phone}</div>}
                          </div> */}
                          {/* <div className='col-md-6'></div> */}

                          {/* <div className="col-md-6">
                          <div className="form-control-info">
                            <Form.Control
                              className="form-input"
                              as="select"
                              name="country"
                              style={{ paddingLeft: "15px" }}
                              value={formData.country}
                              onChange={handleChange}
                            >
                              <option key="" value="">
                                Select Country
                              </option>
                              {Object.keys(countryOptions).map((key) => (
                                <option key={`country-${key}`} value={key}>
                                  {countryOptions[key]}
                                </option>
                              ))}
                            </Form.Control>
                            <label htmlFor="text" className="form-label">
                              Country{" "}
                            </label>
                          </div>
                          {errors.country && (
                            <div className="text-danger custom_error_msg pt-2 px-2">
                              {errors.country}
                            </div>
                          )}
                        </div> */}

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.credits}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Credits
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.allowed_subscription_quota}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Subscription Quota
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.growth_iq ? "Yes" : "No"}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Growth IQ Access
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={
                                  formData.has_comp_iq_access ? "Yes" : "No"
                                }
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Competitor IQ Access
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.no_of_comp_iq_access_limit}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Competitor IQ Limit
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={
                                  formData.has_ask_growth_access ? "Yes" : "No"
                                }
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Ask Growth IQ Access
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.no_of_ask_growth_limit}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Ask Growth IQ Limit
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-control-info">
                              <Form.Control
                                type="text"
                                className="form-input"
                                style={{ marginLeft: "5px" }}
                                value={formData.no_of_deep_research_limit}
                                disabled="disabled"
                              />
                              <Form.Label className="form-label">
                                Deep Research Limit
                              </Form.Label>
                            </div>
                          </div>

                          <div className="col-md-6"></div>

                          <div className="col-md-6"></div>
                        </div>

                        <div className="col-md-12  pt-2">
                          <div className="prev_next_block float-end">
                            <Button
                              type="button"
                              onClick={handleCancel}
                              className="previous_btn mr-2"
                            >
                              Cancel
                            </Button>
                            {/* <Button
                            type="submit"
                            className="personalisation_button"
                          >
                            Next
                          </Button> */}

                            <Button
                              type="submit"
                              // className="personalisation_button"
                              className="add_account_companies"
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "rgb(35, 36, 40)",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "rgb(255, 255, 255)",
                                border: "none",
                                borderRadius: "6px",
                              }}
                              onClick={handleLogout}
                            >
                              Sign out
                            </Button>
                          </div>
                        </div>

                        <div
                          className="cancel_cross_btn"
                          onClick={handleCancel}
                          title="Cancel"
                          style={{
                            position: "absolute",
                            top: "0px",
                            right: "0px",
                            cursor: "pointer",
                            zIndex: 1,
                          }}
                        >
                          {/* <FeatherIcon.X size={18} /> */}
                          <span style={{ padding: "5px" }}>x</span>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// import React, { useState,useEffect } from 'react';
// import useAuth from '../../hooks/useAuth';
// import APP_CONFIG from '../../config/appConfig';
// import { useUser } from '../../context/UserContext';

// export default function ViewProfile(props) {
//     useAuth(); //User Authentication

//     const userRoles = APP_CONFIG.user_roles;
//     const countries = APP_CONFIG.country_options;
//     const { user } = useUser();

//     return (
//         <div className="add_company_wrapper">
//             <div className="container mt-3 p-4">
//                 <h4 className="blue add_user_heading">View Profile</h4>
//                 <div className="row pt-4">
//                     <div className="col-md-12">
//                         <div className="mb-3 row">
//                             <div className="col-md-6 ">
//                                 <div className="view_profile_block">
//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <p className="left_label_profile">Name :</p>
//                                     </div>
//                                     <div className="col-md-9">
//                                         <p className="right_label_profile">{user?.firstname} {user?.lastname}</p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6 ">
//                             <div className="view_profile_block">
//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <p className="left_label_profile">Email :</p>
//                                     </div>
//                                     <div className="col-md-8">
//                                         <p className="right_label_profile">{user?.email} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <p className="left_label_profile">Contact :</p>
//                                     </div>
//                                     <div className="col-md-9">
//                                         <p className="right_label_profile">{user?.phone} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <p className="left_label_profile">User role :</p>
//                                     </div>
//                                     <div className="col-md-8">
//                                         <p className="right_label_profile">{userRoles[user?.role]} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">
//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <p className="left_label_profile">Country :</p>
//                                     </div>
//                                     <div className="col-md-9">
//                                         <p className="right_label_profile">{countries[user?.country]} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <p className="left_label_profile">Company name :</p>
//                                     </div>
//                                     <div className="col-md-8">
//                                         <p className="right_label_profile">{user?.company_name} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <p className="left_label_profile">Designation :</p>
//                                     </div>
//                                     <div className="col-md-9">
//                                         <p className="right_label_profile">{user?.designation} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <p className="left_label_profile">Download access :</p>
//                                     </div>
//                                     <div className="col-md-8">
//                                         <p className="right_label_profile">{(user?.download_access === 0) ? "No" : "Yes"} </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-6">
//                             <div className="view_profile_block">

//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <p className="left_label_profile">Verified :</p>
//                                     </div>
//                                     <div className="col-md-9">
//                                         <p className="right_label_profile">{(user?.isVerified === 0) ? "No" : "Yes" } </p>
//                                     </div>
//                                 </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
